import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { isSmallPromoWidth } from 'config/promoGameTypes';

export default function useContainerWidth() {
    const { type } = useSelector(s => s.promo);
    const location = useLocation();

    const isBigWidthPage = checkPage(getFinalPath(location));
    const shouldUseBigWidth = !isSmallPromoWidth(type) && isBigWidthPage;
    return {
        shouldUseBigWidth,
        maxWidth: shouldUseBigWidth ? 960 : 720,
        breakpoint: shouldUseBigWidth ? 767 : 720
    };
}

function getFinalPath(location) {
    const pathName = location.pathname;
    const splitPath = pathName.split('/');
    return splitPath[3];
}

function checkPage(page) {
    if (page === 'join' || page === 'result' || page === 'prize') {
        return true;
    } else {
        return false;
    }
}
